/* R&D Industries theme behaviour: mobile menu, material tabs, cart count. */
(function () {
  // Mobile menu
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    var menu = document.getElementById('MobileMenu');
    if (!menu) return;
    if (toggle) {
      var open = menu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    } else if (e.target.closest('#MobileMenu a')) {
      menu.classList.remove('open');
      var t = document.querySelector('[data-menu-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    }
  });

  // Material tabs — delegated so it keeps working after theme-editor reloads
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mat-tab');
    if (!btn) return;
    var root = btn.closest('[data-mat-tabs]');
    if (!root) return;
    var id = btn.dataset.tab;
    root.querySelectorAll('.mat-tab').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    root.querySelectorAll('.mat-panel').forEach(function (p) {
      p.classList.toggle('active', p.dataset.panel === id);
    });
  });

  // Cart count refresh (used after the quoter adds to cart)
  window.RD = window.RD || {};
  window.RD.refreshCartCount = function () {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      })
      .catch(function () {});
  };
})();
